export default function Hero() {
  const handleExplorePrograms = () => {
    const programsSection = document.getElementById('training-programs');
    if (programsSection) {
      programsSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  const handleScheduleConsultation = () => {
    const ctaSection = document.getElementById('cta-section');
    if (ctaSection) {
      ctaSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <section className="relative min-h-screen flex items-center pt-20 bg-gray-950 overflow-hidden">
      <div 
        className="absolute inset-0 z-0"
        style={{
          backgroundImage: 'url(https://public.readdy.ai/ai/img_res/8c61739a2d86c5aacc616b48e93791ec.jpg)',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-b from-gray-950/90 via-gray-950/85 to-gray-950"></div>
      </div>

      <div className="relative w-full mx-auto px-6 lg:px-16 py-20 z-10">
        <div className="max-w-4xl mx-auto text-center">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-teal-500/10 border border-teal-500/20 rounded-full mb-8">
            <i className="ri-graduation-cap-line text-teal-400"></i>
            <span className="text-teal-400 text-sm font-medium">Professional Training Programs</span>
          </div>

          <h1 className="text-5xl md:text-7xl font-bold text-white mb-6" style={{ fontFamily: '"Space Grotesk", sans-serif' }}>
            Master the Future of
            <span className="block mt-2 bg-gradient-to-r from-teal-400 to-cyan-400 bg-clip-text text-transparent">
              Technology
            </span>
          </h1>

          <p className="text-xl text-gray-300 mb-12 max-w-3xl mx-auto leading-relaxed">
            Elevate your career with expert-led training in Cloud Computing, Automation, DevOps, and Cybersecurity. Learn from industry professionals and gain hands-on experience with cutting-edge technologies.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <button 
              onClick={handleExplorePrograms}
              className="px-8 py-4 bg-teal-500 text-gray-900 rounded-lg hover:bg-teal-400 transition-all cursor-pointer whitespace-nowrap font-semibold text-lg shadow-lg shadow-teal-500/20"
            >
              Explore Programs
            </button>
            <button 
              onClick={handleScheduleConsultation}
              className="px-8 py-4 bg-transparent text-white rounded-lg font-semibold text-lg border-2 border-gray-600 hover:bg-gray-800/50 hover:border-teal-400 transition-all cursor-pointer whitespace-nowrap"
            >
              Schedule Consultation
            </button>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mt-20 max-w-4xl mx-auto">
            <div className="text-center">
              <div className="text-4xl font-bold text-teal-400 mb-2">500+</div>
              <div className="text-gray-400 text-sm">Students Trained</div>
            </div>
            <div className="text-center">
              <div className="text-4xl font-bold text-teal-400 mb-2">95%</div>
              <div className="text-gray-400 text-sm">Success Rate</div>
            </div>
            <div className="text-center">
              <div className="text-4xl font-bold text-teal-400 mb-2">20+</div>
              <div className="text-gray-400 text-sm">Expert Instructors</div>
            </div>
            <div className="text-center">
              <div className="text-4xl font-bold text-teal-400 mb-2">100+</div>
              <div className="text-gray-400 text-sm">Hours Content</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}